import { PlayerPropKey } from '@pff-consumer/schema'
import { PLAYER_PROPS_FILTER_ORDER } from './player-prop-constants'

export function sortPropTypes(propTypes: PlayerPropKey[]) {
  return propTypes.sort((a, b) => PLAYER_PROPS_FILTER_ORDER.indexOf(a) - PLAYER_PROPS_FILTER_ORDER.indexOf(b))
}
